import type { AnchorHTMLAttributes, FC, MouseEvent, ReactNode } from 'react'
import type { ServiceKey } from '@/types'

import { requestPrefill } from '@/lib/quote-prefill'
import { SectionLink } from '@/components/generals/section-link'
import { QUOTE_HASH } from '@/constants/site'

interface QuoteLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
    service?: ServiceKey
    children: ReactNode
}

/** A link to the free quote form that can pre-select the service it was clicked from. */
export const QuoteLink: FC<QuoteLinkProps> = ({ service, onClick, children, ...rest }) => {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        if (service) requestPrefill(service)
        onClick?.(event)
    }

    return (
        <SectionLink hash={QUOTE_HASH} onClick={handleClick} {...rest}>
            {children}
        </SectionLink>
    )
}
